// extracted by mini-css-extract-plugin
module.exports = {"contentStyles":"styles_contentStyles__3_8vx","videoContainer":"styles_videoContainer__1-Jwj"};